/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDUturnLeftUpIcon16Light } from './ArrowDUturnLeftUpIcon16Light';
import { ArrowDUturnLeftUpIcon16Regular } from './ArrowDUturnLeftUpIcon16Regular';
import { ArrowDUturnLeftUpIcon16Solid } from './ArrowDUturnLeftUpIcon16Solid';
import { ArrowDUturnLeftUpIcon20Light } from './ArrowDUturnLeftUpIcon20Light';
import { ArrowDUturnLeftUpIcon20Regular } from './ArrowDUturnLeftUpIcon20Regular';
import { ArrowDUturnLeftUpIcon20Solid } from './ArrowDUturnLeftUpIcon20Solid';
import { ArrowDUturnLeftUpIcon24Regular } from './ArrowDUturnLeftUpIcon24Regular';
import { ArrowDUturnLeftUpIcon24Solid } from './ArrowDUturnLeftUpIcon24Solid';
import { ArrowDUturnLeftUpIcon32Regular } from './ArrowDUturnLeftUpIcon32Regular';
import { ArrowDUturnLeftUpIcon64Regular } from './ArrowDUturnLeftUpIcon64Regular';
var sizes = {
    16: {
        light: ArrowDUturnLeftUpIcon16Light,
        regular: ArrowDUturnLeftUpIcon16Regular,
        solid: ArrowDUturnLeftUpIcon16Solid,
    },
    20: {
        light: ArrowDUturnLeftUpIcon20Light,
        regular: ArrowDUturnLeftUpIcon20Regular,
        solid: ArrowDUturnLeftUpIcon20Solid,
    },
    24: {
        regular: ArrowDUturnLeftUpIcon24Regular,
        solid: ArrowDUturnLeftUpIcon24Solid,
    },
    32: {
        regular: ArrowDUturnLeftUpIcon32Regular,
    },
    64: {
        regular: ArrowDUturnLeftUpIcon64Regular,
    },
};
export var ArrowDUturnLeftUpIcon = forwardRef('ArrowDUturnLeftUpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
